import React from "react";
import "./FeaturesSection.css";

const FeaturesSection: React.FC = () => {
  return (
    <section className="features">
      <div className="features-container">
        <h2 className="features-title">Making your life easier</h2>
        <p className="features-description">
          Accept any payment method and get paid instantly to your bank account.
          Manage all your income from one dashboard. Replace weeks of tax prep
          with one click.
        </p>

        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-card-image">
              <video
                src="/assets-project/videos/frame-12.mp4"
                width="100%"
                autoPlay
                muted
                loop
                playsInline
                aria-label="Payment Methods"
              />
            </div>
            <div className="feature-card-content">
              <h3 className="feature-card-title">Payment Methods</h3>
              <p className="feature-card-description">
                Be ready for the payment methods your clients use today and the
                ones they will use tomorrow. Pagarva has you covered.
              </p>
            </div>
          </div>

          <div className="feature-card">
            <div className="feature-card-image">
              <video
                src="/assets-project/videos/frame-13.mp4"
                width="100%"
                autoPlay
                muted
                loop
                playsInline
                aria-label="One App"
              />
            </div>
            <div className="feature-card-content">
              <h3 className="feature-card-title">One App</h3>
              <p className="feature-card-description">
                Have complete visibility of your income in a single dashboard.
                Know how your business is performing with one click.
              </p>
            </div>
          </div>

          <div className="feature-card">
            <div className="feature-card-image">
              <video
                src="/assets-project/videos/frame-14.mp4"
                width="100%"
                autoPlay
                muted
                loop
                playsInline
                aria-label="Bank Deposits"
              />
            </div>
            <div className="feature-card-content">
              <h3 className="feature-card-title">Bank Deposits</h3>
              <p className="feature-card-description">
                If you cannot use it now, it is not instant. That is why we
                deposit your money straight into your bank account.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
